<div>
  <app-breadcrumb
    [breadcrumbItems]="{
      currentPageLink: '/about-us',
      currentPage: 'About Us'
    }"
  />

  <div class="custom-container">
    <div class="about-us-wrapper">
      <app-section-heading [sectionHeading]="aboutUs.sectionHeading" />

      <div class="about-us-cards">
        <div class="about-us-card" *ngFor="let cardInfo of aboutUs.infoCards">
          <img [src]="cardInfo.icon.src" [alt]="cardInfo.icon.alt" />
          <p class="base-text mt-15">{{ cardInfo.info }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
